<template>
  <v-card outlined class="mx-auto list-item white-blur">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="text-h6 mb-1">
          <div class="d-flex align-center justify-space-between">
            <div class="list-item-title">
              <v-icon :color="value.color">
                {{ value.icon }}
              </v-icon>
              {{ value.name }}
            </div>
            <div>
              <v-chip label :color="getType(value).color" dark>
                {{ getType(value).text }}
              </v-chip>
            </div>
          </div>
        </v-list-item-title>
        <v-list-item-subtitle>{{ value.question }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
    
    </v-card-text>

    <v-card-actions class="card-actions-bottom">
      <v-btn outlined text @click="() => $emit('onDetails', value)">
        View Details
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
  
  
<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
    getType(item) {
      switch (item.type) {
        case "string":
          return {
            color: "green",
            text: "String",
          };
        case "number":
          return {
            color: "blue",
            text: "Number",
          };
        case "boolean":
          return {
            color: "red",
            text: "Boolean",
          };
        case "date":
          return {
            color: "purple",
            text: "Date",
          };
        case "object":
          return {
            color: "orange",
            text: "Object",
          };
        case "array":
          return {
            color: "pink",
            text: "Array",
          };
        default:
          return {
            color: "grey",
            text: "Unknown",
          };
      }
    },
  },
};
</script>
  
  
  <style lang="scss" scoped>
.list-item {
  overflow: hidden;
  height: 200px;

  .list-item-title{
    max-width: 75%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>